import { cloneElement, ComponentPropsWithRef, ReactElement, ReactNode, useState } from "react";
import styles from "./Tooltip.module.css";
import { flip, FloatingPortal, useFloating, useHover, useInteractions } from "@floating-ui/react";

type TooltipProps = {
  children: ReactElement<ComponentPropsWithRef<"div">>;
  content: ReactNode;
  enabled?: boolean;
};

export function Tooltip({ children, enabled = true, content }: TooltipProps) {
  const [isOpen, setIsOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [flip()],
  });

  const hover = useHover(context, { enabled });
  const { getReferenceProps, getFloatingProps } = useInteractions([hover]);

  const child = cloneElement(children, {
    ref: refs.setReference,
    ...getReferenceProps(),
  });

  return (
    <>
      {child}
      {isOpen && (
        <FloatingPortal>
          <div
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
            className={styles.tooltip}
          >
            {content}
          </div>
        </FloatingPortal>
      )}
    </>
  );
}
